import { mount } from "@vue/test-utils";
import StepCounter from "@/components/core/StepCounter";

jest.mock("@/components/core/StepCounter", () => ({
  ...jest.requireActual("@/components/core/StepCounter"),
  methods: {
    cantPasos: jest.fn()
  }
}));

describe("StepCounter test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(StepCounter, {
      props: {
        paso: "asdas"
      }
    });
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component StepCounter", () => {
    expect(wrapper).toBeDefined();
  });
});
